export interface TInteractiveState {
  interactive: string | null;
  test: TInteractiveTest | null;
  vote: TInteractiveVote | null;
  voteRating: TVoteRating | null;
  link: TLinks | null;
  testResult: TTestResult | null;
  voteResult: TVoteResult | null;
  voteRatingResult: TVoteRating | null;
  votesGroup: TVotesGroup | null;
  votesRatingGroup: TVotesGroup | null;
  rating: RatingType | null;
  doneTest: { done: 0 | 1; points: number } | null;
  doneVote: { done: 0 | 1 } | null;
  doneVoteGroup: TDoneVoteGroup | null;
  doneVoteRating: TDoneVoteRating | null;
  doneVoteRatingGroup: TDoneVoteRatingGroup | null;
  error: string | null;
  loading: boolean;
  redirect: string | null;
}

export interface RatingType {
  id: number;
  title: string;
  rating: {
    userId: string;
    fio: string;
    points: number;
    position: number;
  }[];
}

export interface TDoneVoteRating {
  done: number;
  points: number;
  total: number;
}

export interface TDoneVoteGroup {
  doneVotes: { id: number }[];
}

export interface TDoneVoteRatingGroup {
  doneVotes: { id: number }[];
  points: number;
  total: number;
}

export interface TDataShowInteractive {
  event_id: number;
  roomId: number;
}

export interface TDataCheckDoneTest {
  event_id: number;
  roomId: number;
  testId: number;
}

export interface TDataCheckDoneVote {
  event_id: number;
  roomId: number;
  voteId: number;
}

export interface TDataCheckDoneVoteGroup {
  event_id: number;
  roomId: number;
  votesGroupId: number;
}

export interface TAnswerInteractiveTest {
  event_id: number;
  roomId: number;
  testId: number;
  data: TAnswerTest[];
}

export interface TAnswerTest {
  questionId: number;
  answerId: number;
}

export interface TAnswerInteractiveVote {
  event_id: number;
  roomId: number;
  voteId: number;
  answerId: number;
}

export interface TAnswerInteractiveVoteRating extends TAnswerInteractiveVote {}

export interface TAnswerInteractiveVoteGroup {
  event_id: number;
  roomId: number;
  votesGroupId: number;
  voteId: number;
  answerId: number;
}

export interface TInteractive {
  interId: number;
  interType: number;
  interactive: TInteractiveTest | TInteractiveVote | TVoteRating | TLinks | TTestResult | TVoteResult | TVotesGroup | RatingType;
}

export interface TInteractiveTest {
  id: number;
  title: string;
  questions: TResponseTestsQuestions[];
  isFinish: number;
}

export interface TResponseTestsQuestions {
  id: number;
  question_id: number;
  test_id: number;
  name: string;
  comment: string;
  status: number;
  createDate: Date;
  createdBy: number;
  answers: TTestsAnswers[];
}

export interface TTestsAnswers {
  id: number;
  question_id: number;
  test_id: number;
  name: string;
  points: number;
  is_correct: number;
  createDate: Date;
}

export interface TInteractiveVote {
  id: number;
  title: string;
  questions: TVotesVariants[];
  isFinish: number;
}

export interface TVotesVariants {
  id: number;
  user_id: string;
  name: string;
  createDate: Date;
}

export interface TLinks {
  id: number;
  event_id: string;
  title: string;
  body: string;
  name_button: string;
  link_button: string;
  default: number;
}

export interface TTestResult {
  id: number;
  title: string;
  columns: { pos: number; value: number }[];
}

export interface TVoteResult {
  id: number;
  title: string;
  params: { pos: number; title: string; value: number }[];
}

export interface TVotesGroup {
  id: number;
  votesGroup: { id: number; total: number }[];
  startTime: Date;
  votes: TInteractiveVote[];
  status: number;
}

export interface TVoteEnd {
  id: number;
  name: string;
  status: number;
}

export interface TVoteRating {
  id: number;
  title: string;
  questions: TVotesRatingAnswers[];
  timeout: number;
  startTime: Date;
  isFinish: number;
}

export interface TVotesRatingAnswers {
  id: number;
  voteId: number;
  name: string;
  points: number;
  isCorrect: number;
  createDate: Date;
}

enum ActionTypes {
  SET_TEST = 'SET_TEST',
  SET_VOTE = 'SET_VOTE',
  SET_VOTE_RATING = 'SET_VOTE_RATING',
  SET_LINK = 'SET_LINK',
  SET_RESULT_TEST = 'SET_RESULT_TEST',
  SET_RESULT_VOTE = 'SET_RESULT_VOTE',
  SET_RESULT_VOTE_RATING = 'SET_RESULT_VOTE_RATING',
  SET_INTERACTIVE = 'SET_INTERACTIVE',
  SET_REDIRECT = 'SET_REDIRECT',
  SET_VOTES_GROUP = 'SET_VOTES_GROUP',
  SET_VOTES_RATING_GROUP = 'SET_VOTES_RATING_GROUP',
  SET_END_VOTE = 'SET_END_VOTE',
  SET_END_VOTE_RATING = 'SET_END_VOTE_RATING',
  SET_RATING = 'SET_RATING',

  CLEAR_INTERACTIVE = 'CLEAR_INTERACTIVE',

  SHOW_INTERACTIVE_R = 'SHOW_INTERACTIVE_R',
  SHOW_INTERACTIVE_S = 'SHOW_INTERACTIVE_S',
  SHOW_INTERACTIVE_E = 'SHOW_INTERACTIVE_E',

  SEND_TEST_R = 'SEND_TEST_R',
  SEND_TEST_S = 'SEND_TEST_S',
  SEND_TEST_E = 'SEND_TEST_E',

  SEND_VOTE_R = 'SEND_VOTE_R',
  SEND_VOTE_S = 'SEND_VOTE_S',
  SEND_VOTE_E = 'SEND_VOTE_E',

  SEND_VOTE_RATING_R = 'SEND_VOTE_RATING_R',
  SEND_VOTE_RATING_S = 'SEND_VOTE_RATING_S',
  SEND_VOTE_RATING_E = 'SEND_VOTE_RATING_E',

  SEND_VOTE_GROUP_R = 'SEND_VOTE_GROUP_R',
  SEND_VOTE_GROUP_S = 'SEND_VOTE_GROUP_S',
  SEND_VOTE_GROUP_E = 'SEND_VOTE_GROUP_E',

  SEND_VOTE_RATING_GROUP_R = 'SEND_VOTE_RATING_GROUP_R',
  SEND_VOTE_RATING_GROUP_S = 'SEND_VOTE_RATING_GROUP_S',
  SEND_VOTE_RATING_GROUP_E = 'SEND_VOTE_RATING_GROUP_E',

  CHECK_DONE_TEST_R = 'CHECK_DONE_TEST_R',
  CHECK_DONE_TEST_S = 'CHECK_DONE_TEST_S',
  CHECK_DONE_TEST_E = 'CHECK_DONE_TEST_E',

  CHECK_DONE_VOTE_R = 'CHECK_DONE_VOTE_R',
  CHECK_DONE_VOTE_S = 'CHECK_DONE_VOTE_S',
  CHECK_DONE_VOTE_E = 'CHECK_DONE_VOTE_E',

  CHECK_DONE_VOTE_RATING_R = 'CHECK_DONE_VOTE_RATING_R',
  CHECK_DONE_VOTE_RATING_S = 'CHECK_DONE_VOTE_RATING_S',
  CHECK_DONE_VOTE_RATING_E = 'CHECK_DONE_VOTE_RATING_E',

  CHECK_DONE_VOTE_GROUP_R = 'CHECK_DONE_VOTE_GROUP_R',
  CHECK_DONE_VOTE_GROUP_S = 'CHECK_DONE_VOTE_GROUP_S',
  CHECK_DONE_VOTE_GROUP_E = 'CHECK_DONE_VOTE_GROUP_E',

  CHECK_DONE_VOTE_RATING_GROUP_R = 'CHECK_DONE_VOTE_RATING_GROUP_R',
  CHECK_DONE_VOTE_RATING_GROUP_S = 'CHECK_DONE_VOTE_RATING_GROUP_S',
  CHECK_DONE_VOTE_RATING_GROUP_E = 'CHECK_DONE_VOTE_RATING_GROUP_E',

  GET_DEFAULT_LINK_R = 'GET_DEFAULT_LINK_R',
  GET_DEFAULT_LINK_S = 'GET_DEFAULT_LINK_S',
  GET_DEFAULT_LINK_E = 'GET_DEFAULT_LINK_E',
}

export default ActionTypes;
